import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Svg from '@eversports/klimt-primitives/legacy/Svg'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../../../localization/react'
import type { Venue } from '../../ActivityDetails.types'
import Star from '../assets/star.svg'

interface Props {
  venue: Venue
}

const NoReviews = ({ venue }: Props) => (
  <Stack direction="row" gap={2}>
    <Stack direction="row" alignItems="center" gap={1}>
      <Svg src={Star} width={12} height={12} />
      <Text color="midnight" sx={{ fontWeight: 'bold' }}>
        <Localized id="activity-details-venue-reviews-header" />
      </Text>
    </Stack>
    <Stack direction="row" gap={1}>
      {venue.rating && (
        <Text color="midnight" sx={{ fontWeight: 'bold' }}>
          {venue.rating.toFixed(2)}
        </Text>
      )}
      <Text>
        <Localized id="rating-no-reviews" />
      </Text>
    </Stack>
  </Stack>
)

export default NoReviews
